import { InjectionToken } from '@angular/core';
import { ILogger } from '../services/logger/i-logger';

export const LOGGER: InjectionToken<ILogger> = new InjectionToken('LOG_PROVIDER');
